import script from "./ButtonLegend.vue?vue&type=script&setup=true&lang=js"
export * from "./ButtonLegend.vue?vue&type=script&setup=true&lang=js"

import "./ButtonLegend.vue?vue&type=style&index=0&id=6bd58fee&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6bd58fee"]])

export default __exports__